<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconImport_16"
    viewBox="0 0 16 17"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M3.193 4.717 7.733.176a.602.602 0 0 1 .851 0l4.541 4.541a.602.602 0 0 1-.693.965L9.084 4.018v6.407a.926.926 0 0 1-1.851 0V4.018L3.885 5.68a.601.601 0 0 1-.692-.964ZM1.7 11.65a.7.7 0 0 1 .7.7v2.1h11.2v-2.1a.7.7 0 1 1 1.4 0v2.8a.7.7 0 0 1-.7.7H1.7a.7.7 0 0 1-.7-.7v-2.799a.7.7 0 0 1 .7-.7Z"
    />
</svg>
